import { useMemo } from 'react'
import { MANUAL_VERIFICATION_PAGE_VERIFICATION_STATES } from '../models/IManualVerificationPageModel'
import useTextContents from '../../../hooks/useTextContents'
import { useSelector } from 'react-redux'
import { AppState } from '../../../store'
import { isEmpty } from 'lodash'
import { DateTime } from 'luxon'


//todo do spr w nowej openie (workfrom)
export const useGetManualVerificationContentBasedOnBackendData = (): string => {
  const textContent = useTextContents()

  const DEFAULT_MANUAL_VERIFICATION_WORK_FROM = '9:00:00'
   const { manualVerificationPageHubVerificationState, workFrom } = useSelector((state: AppState) => state.applicationState.manualVerificationState)
   const manualVerificationPhoneNumberFromState = useSelector((state: AppState) => state.lenConfigState.globalConfig.manualVerificationPhoneNumber)
   const manualVerificationPhoneNumber = isEmpty(manualVerificationPhoneNumberFromState)? "58 73 900 99" : manualVerificationPhoneNumberFromState

   return useMemo(() => {
     switch (manualVerificationPageHubVerificationState?.toLowerCase()) {
       case MANUAL_VERIFICATION_PAGE_VERIFICATION_STATES.TODAY.toLowerCase():
           return textContent('manualVerificationPage.mainContentTextUp.workdays_workhours', {
                   manualVerificationPhoneNumber,
                 })

       case MANUAL_VERIFICATION_PAGE_VERIFICATION_STATES.TODAY_AFTER_MIDNIGHT.toLowerCase():
         return textContent('manualVerificationPage.mainContentTextUp.workdays_out_of_workhours_alternative', {
           manualVerificationPhoneNumber,
           workFrom: DateTime.fromFormat(workFrom ?? DEFAULT_MANUAL_VERIFICATION_WORK_FROM, "HH:mm:ss").toFormat("HH:mm"),
         })

       case MANUAL_VERIFICATION_PAGE_VERIFICATION_STATES.TOMORROW.toLowerCase():
         return textContent('manualVerificationPage.mainContentTextUp.workdays_out_of_workhours', {
           manualVerificationPhoneNumber,
           workFrom: DateTime.fromFormat(workFrom ?? DEFAULT_MANUAL_VERIFICATION_WORK_FROM, "HH:mm:ss").toFormat("HH:mm"),
         })

       case MANUAL_VERIFICATION_PAGE_VERIFICATION_STATES.NEXT_WORKDAY.toLowerCase():
         return textContent('manualVerificationPage.mainContentTextUp.out_of_workdays_out_of_workhours', {
           manualVerificationPhoneNumber,
           workFrom: DateTime.fromFormat(workFrom ?? DEFAULT_MANUAL_VERIFICATION_WORK_FROM, "HH:mm:ss").toFormat("HH:mm"),
         })

       default:
         console.error('Nieznany stan weryfikacji manualnej', manualVerificationPageHubVerificationState)
         return ''
     }
   },
   [ manualVerificationPageHubVerificationState, manualVerificationPhoneNumber, workFrom, textContent ])
}
export const useGetManualVerificationContentDetailsBasedOnBackendData = (): string => {
  const textContent = useTextContents()

  const DEFAULT_MANUAL_VERIFICATION_WORK_FROM = '9:00:00'
   const { manualVerificationPageHubVerificationState, workFrom } = useSelector((state: AppState) => state.applicationState.manualVerificationState)
   const manualVerificationPhoneNumberFromState = useSelector((state: AppState) => state.lenConfigState.globalConfig.manualVerificationPhoneNumber)
   const manualVerificationPhoneNumber = isEmpty(manualVerificationPhoneNumberFromState)? "58 73 900 99" : manualVerificationPhoneNumberFromState

   return useMemo(() => {
     switch (manualVerificationPageHubVerificationState?.toLowerCase()) {
       case MANUAL_VERIFICATION_PAGE_VERIFICATION_STATES.TODAY.toLowerCase():
           return textContent('manualVerificationPage.paymentDetails.workdays_workhours');
       default:
           return textContent('manualVerificationPage.paymentDetails.workdays_out_of_workhours')
     }
   },
   [ manualVerificationPageHubVerificationState, manualVerificationPhoneNumber, workFrom, textContent ])
}